document.addEventListener('DOMContentLoaded', () => {
    
    // --- Hero Slider ---
    const slides = document.querySelectorAll('.slide');
    const prevBtn = document.getElementById('prevSlide');
    const nextBtn = document.getElementById('nextSlide');
    let currentSlide = 0;
    let slideInterval;

    function initSlider() {
        if(slides.length === 0) return;
        
        slides[currentSlide].classList.add('active');
        
        // Auto slide
        slideInterval = setInterval(nextSlideFunc, 5000);

        prevBtn.addEventListener('click', () => {
            clearInterval(slideInterval);
            prevSlideFunc();
            slideInterval = setInterval(nextSlideFunc, 5000);
        });

        nextBtn.addEventListener('click', () => {
            clearInterval(slideInterval);
            nextSlideFunc();
            slideInterval = setInterval(nextSlideFunc, 5000);
        });
    }

    function changeSlide(direction) {
        slides[currentSlide].classList.remove('active');
        slides[currentSlide].style.opacity = 0;
        
        if (direction === 'next') {
            currentSlide = (currentSlide + 1) % slides.length;
        } else {
            currentSlide = (currentSlide - 1 + slides.length) % slides.length;
        }

        slides[currentSlide].classList.add('active');
        slides[currentSlide].style.opacity = 1;
    }

    function nextSlideFunc() { changeSlide('next'); }
    function prevSlideFunc() { changeSlide('prev'); }
    
    initSlider();

    // --- Product Carousels Progress & Auto-Scroll ---
    const carousels = document.querySelectorAll('.product-carousel');
    
    carousels.forEach(carousel => {
        const section = carousel.closest('section');
        const progressBar = section ? section.querySelector('.progress-bar') : null;

        if (progressBar) {
            carousel.addEventListener('scroll', () => {
                const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
                const scrollPercentage = (maxScrollLeft > 0) ? (carousel.scrollLeft / maxScrollLeft) * 100 : 0;
                // Min width to show progress bar base
                const adjustedPercentage = Math.max(20, scrollPercentage); 
                progressBar.style.width = scrollPercentage === 0 ? '20%' : `${adjustedPercentage}%`;
            });
        }

        // Auto-scroll logic
        let carouselInterval = setInterval(autoScrollCarousel, 3000);

        function autoScrollCarousel() {
            const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
            if (maxScrollLeft <= 0) return;
            
            if (carousel.scrollLeft >= maxScrollLeft - 10) {
                carousel.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                carousel.scrollBy({ left: 300, behavior: 'smooth' });
            }
        }

        // Pause on hover
        carousel.addEventListener('mouseenter', () => clearInterval(carouselInterval));
        carousel.addEventListener('mouseleave', () => {
            carouselInterval = setInterval(autoScrollCarousel, 3000);
        });

        // Arrow controls logic
        const leftArrow = section ? section.querySelector('.left-arrow') : null;
        const rightArrow = section ? section.querySelector('.right-arrow') : null;

        if (leftArrow) {
            leftArrow.addEventListener('click', () => {
                carousel.scrollBy({ left: -300, behavior: 'smooth' });
            });
            leftArrow.addEventListener('mouseenter', () => clearInterval(carouselInterval));
            leftArrow.addEventListener('mouseleave', () => carouselInterval = setInterval(autoScrollCarousel, 3000));
        }

        if (rightArrow) {
            rightArrow.addEventListener('click', () => {
                carousel.scrollBy({ left: 300, behavior: 'smooth' });
            });
            rightArrow.addEventListener('mouseenter', () => clearInterval(carouselInterval));
            rightArrow.addEventListener('mouseleave', () => carouselInterval = setInterval(autoScrollCarousel, 3000));
        }
    });

    // --- Canvas Particles Effect ---
    const canvas = document.getElementById('particlesCanvas');
    const heroSection = document.getElementById('heroSection');
    
    if (canvas && heroSection) {
        const ctx = canvas.getContext('2d');
        let particlesArray;
        
        const mouse = { x: null, y: null, radius: 150 };

        function resize() {
            canvas.width = heroSection.offsetWidth;
            canvas.height = heroSection.offsetHeight;
        }

        heroSection.addEventListener('mousemove', e => {
            const rect = heroSection.getBoundingClientRect();
            mouse.x = e.clientX - rect.left;
            mouse.y = e.clientY - rect.top;
        });

        heroSection.addEventListener('mouseout', () => {
            mouse.x = null;
            mouse.y = null;
        });

        window.addEventListener('resize', () => {
            resize();
            initParticles();
        });

        class Particle {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.size = Math.random() * 2 + 1;
                this.speedX = Math.random() * 1 - 0.5;
                this.speedY = Math.random() * 1 - 0.5;
            }
            update() {
                this.x += this.speedX;
                this.y += this.speedY;

                if (this.x > canvas.width || this.x < 0) this.speedX *= -1;
                if (this.y > canvas.height || this.y < 0) this.speedY *= -1;

                if (mouse.x !== null) {
                    let dx = mouse.x - this.x;
                    let dy = mouse.y - this.y;
                    let distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance < mouse.radius) {
                        const forceDirectionX = dx / distance;
                        const forceDirectionY = dy / distance;
                        const force = (mouse.radius - distance) / mouse.radius;
                        this.x -= forceDirectionX * force;
                        this.y -= forceDirectionY * force;
                    }
                }

                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
                ctx.fill();
            }
        }

        function initParticles() {
            particlesArray = [];
            const numberOfParticles = (canvas.width * canvas.height) / 8000;
            for (let i = 0; i < numberOfParticles; i++) {
                particlesArray.push(new Particle());
            }
        }

        function connect() {
            for (let a = 0; a < particlesArray.length; a++) {
                if (mouse.x !== null) {
                    let dx = particlesArray[a].x - mouse.x;
                    let dy = particlesArray[a].y - mouse.y;
                    let distance = dx * dx + dy * dy;
                    if (distance < 25000) {
                        ctx.strokeStyle = `rgba(255, 255, 255, ${1 - distance/25000})`;
                        ctx.lineWidth = 1.5;
                        ctx.beginPath();
                        ctx.moveTo(particlesArray[a].x, particlesArray[a].y);
                        ctx.lineTo(mouse.x, mouse.y);
                        ctx.stroke();
                    }
                }
                
                for (let b = a; b < particlesArray.length; b++) {
                    let dx = particlesArray[a].x - particlesArray[b].x;
                    let dy = particlesArray[a].y - particlesArray[b].y;
                    let distance = dx * dx + dy * dy;
                    
                    if (distance < 15000) {
                        ctx.strokeStyle = `rgba(255, 255, 255, ${(1 - distance/15000) * 0.3})`;
                        ctx.lineWidth = 1;
                        ctx.beginPath();
                        ctx.moveTo(particlesArray[a].x, particlesArray[a].y);
                        ctx.lineTo(particlesArray[b].x, particlesArray[b].y);
                        ctx.stroke();
                    }
                }
            }
        }

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let i = 0; i < particlesArray.length; i++) {
                particlesArray[i].update();
            }
            connect();
            requestAnimationFrame(animate);
        }

        resize();
        initParticles();
        animate();
    }

    // --- Product Color Swatches ---
    const swatches = document.querySelectorAll('.color-swatch');
    swatches.forEach(swatch => {
        swatch.addEventListener('click', (e) => {
            // Prevent default just in case it's placed inside a link later
            e.preventDefault();
            e.stopPropagation();

            // Find closest button if user clicked on the image inside the button
            const btn = e.target.closest('.color-swatch');
            if(!btn) return;

            const newImageSrc = btn.getAttribute('data-image');
            
            // Find parent product card
            const productCard = btn.closest('.product-card');
            if(productCard && newImageSrc) {
                // Update Image (Look for img inside .product-image directly or inside an <a> tag)
                const productImage = productCard.querySelector('.product-image img');
                if(productImage) {
                    productImage.src = newImageSrc;
                }
                
                // Update Active State
                const swatchContainer = btn.closest('.color-swatches');
                swatchContainer.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
                btn.classList.add('active');
            }
        });
    });

    // --- Sticky Header Scroll Effect ---
    const header = document.querySelector('.sticky-header');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            header.style.backgroundColor = 'rgba(0, 0, 0, 0.95)';
            header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.5)';
        } else {
            header.style.backgroundColor = '#000000';
            header.style.boxShadow = 'none';
        }
    });

    // --- Search Overlay Logic ---
    const searchBtns = document.querySelectorAll('.fa-search');
    const searchOverlay = document.getElementById('searchOverlay');
    const closeSearchBtn = document.getElementById('closeSearch');
    
    // Open Search (Find the search icon in the header)
    searchBtns.forEach(btn => {
        // Only attach to the one in the header, not the one inside the input
        if(btn.closest('.header-right')) {
            btn.parentElement.addEventListener('click', (e) => {
                e.preventDefault();
                searchOverlay.classList.add('active');
            });
        }
    });

    // Close Search
    if(closeSearchBtn) {
        closeSearchBtn.addEventListener('click', () => {
            searchOverlay.classList.remove('active');
        });
    }

    // Filter Accordions
    const filterTitles = document.querySelectorAll('.filter-title');
    filterTitles.forEach(title => {
        title.addEventListener('click', () => {
            const options = title.nextElementSibling;
            const icon = title.querySelector('i');
            
            if (options.style.display === 'none') {
                options.style.display = 'flex';
                icon.classList.replace('fa-chevron-right', 'fa-chevron-down');
            } else {
                options.style.display = 'none';
                icon.classList.replace('fa-chevron-down', 'fa-chevron-right');
            }
        });
    });

    // Size Selection Active State
    const sizeBtns = document.querySelectorAll('.size-btn');
    sizeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            btn.classList.toggle('active');
        });
    });

    // Color Selection Active State
    const colorFilterBtns = document.querySelectorAll('.color-filter-btn');
    colorFilterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            btn.classList.toggle('active');
        });
    });

    // Clear Filters
    const clearFiltersBtn = document.querySelector('.clear-filters');
    if(clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', () => {
            // Uncheck checkboxes
            document.querySelectorAll('.custom-checkbox input').forEach(cb => cb.checked = false);
            // Remove active from sizes
            sizeBtns.forEach(btn => btn.classList.remove('active'));
            // Remove active from colors
            colorFilterBtns.forEach(btn => btn.classList.remove('active'));
            // Clear search input
            // Clear search input
            document.getElementById('searchInput').value = '';
        });
    }

    // --- Mobile Menu Toggle ---
    const menuToggle = document.querySelector('.menu-toggle');
    const desktopNav = document.querySelector('.desktop-nav');
    if (menuToggle && desktopNav) {
        menuToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            desktopNav.classList.toggle('active-mobile');
        });
        
        const mobileLinks = desktopNav.querySelectorAll('a');
        mobileLinks.forEach(link => {
            link.addEventListener('click', () => {
                desktopNav.classList.remove('active-mobile');
            });
        });
        
        document.addEventListener('click', (e) => {
            if (!desktopNav.contains(e.target) && !menuToggle.contains(e.target)) {
                desktopNav.classList.remove('active-mobile');
            }
        });
    }

    // --- Quick View Modal & Size Guide Logic ---
    const productModal = document.getElementById('productModal');
    const closeProductModalBtn = document.getElementById('closeProductModal');
    const quickViewBtns = document.querySelectorAll('.quick-view-btn');

    // To store the current product's variants
    let currentVariants = [];
    let selectedVariantId = null;

    quickViewBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            
            const card = btn.closest('.product-card');
            if(card && productModal) {
                // Determine gender context if needed for the size guide
                const isHombres = card.closest('#destacadosHombres') !== null;
                
                // Show loading state...
                const productUrl = btn.getAttribute('href');
                
                fetch(productUrl + '.js')
                .then(response => response.json())
                .then(product => {
                    currentVariants = product.variants;
                    
                    // Inject data into the modal
                    const modalImg = productModal.querySelector('.main-image-container img');
                    const modalThumbs = productModal.querySelector('.thumbnail-list');
                    
                    // Clear old thumbs
                    if (modalThumbs) {
                        modalThumbs.innerHTML = '';
                        if (product.images && product.images.length > 0) {
                            product.images.slice(0,4).forEach((imgSrc, index) => {
                                const img = document.createElement('img');
                                img.src = imgSrc;
                                img.className = index === 0 ? 'gallery-thumb active' : 'gallery-thumb';
                                modalThumbs.appendChild(img);
                                
                                img.addEventListener('click', () => {
                                    modalThumbs.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
                                    img.classList.add('active');
                                    if(modalImg) modalImg.src = imgSrc;
                                });
                            });
                        }
                    }
                    
                    if (modalImg && product.featured_image) {
                        modalImg.src = product.featured_image;
                    }
                    
                    const modalTitle = productModal.querySelector('h1.product-title');
                    if (modalTitle) modalTitle.textContent = product.title;
                    
                    const breadcrumbSpan = productModal.querySelector('.breadcrumbs span');
                    if (breadcrumbSpan) breadcrumbSpan.textContent = product.title;
                    
                    const modalDiscountBadge = document.getElementById('modalDiscountBadge');
                    const modalCurrentPrice = productModal.querySelector('.current-price');
                    const modalComparePrice = productModal.querySelector('.compare-price');
                    
                    if (modalCurrentPrice) {
                        modalCurrentPrice.textContent = '$' + (product.price / 100).toLocaleString('es-CO') + ' COP';
                    }
                    
                    if (modalComparePrice) {
                        if (product.compare_at_price > product.price) {
                            modalComparePrice.textContent = '$' + (product.compare_at_price / 100).toLocaleString('es-CO') + ' COP';
                            modalComparePrice.style.display = 'inline-block';
                            
                            if (modalDiscountBadge) {
                                const diff = product.compare_at_price - product.price;
                                const perc = Math.round((diff / product.compare_at_price) * 100);
                                modalDiscountBadge.textContent = '-' + perc + '%';
                                modalDiscountBadge.style.display = 'block';
                            }
                        } else {
                            modalComparePrice.style.display = 'none';
                            if (modalDiscountBadge) modalDiscountBadge.style.display = 'none';
                        }
                    }

                    // Generate size buttons based on variants
                    const sizeGrid = productModal.querySelector('.size-grid-selection');
                    if (sizeGrid) {
                        sizeGrid.innerHTML = '';
                        selectedVariantId = null;
                        
                        product.variants.forEach((variant) => {
                            const btn = document.createElement('button');
                            btn.className = 'size-box';
                            if (!variant.available) btn.classList.add('out-of-stock');
                            btn.textContent = variant.title;
                            btn.dataset.id = variant.id;
                            
                            // Auto-select first available
                            if (variant.available && !selectedVariantId) {
                                btn.classList.add('active');
                                selectedVariantId = variant.id;
                            }
                            
                            btn.addEventListener('click', () => {
                                if(variant.available) {
                                    sizeGrid.querySelectorAll('.size-box').forEach(b => b.classList.remove('active'));
                                    btn.classList.add('active');
                                    selectedVariantId = variant.id;
                                }
                            });
                            
                            sizeGrid.appendChild(btn);
                        });
                    }

                    // Adjust Size Guide modal based on gender
                    const sizeGuideTitle = document.getElementById('sizeGuideTitle');
                    const tableDamas = document.getElementById('sizeTableDamas');
                    const tableHombres = document.getElementById('sizeTableHombres');
                    
                    if (sizeGuideTitle) {
                        sizeGuideTitle.textContent = isHombres ? 'Guía de Tallas (Hombres)' : 'Guía de Tallas (Damas)';
                    }
                    if (tableDamas && tableHombres) {
                        if (isHombres) {
                            tableDamas.style.display = 'none';
                            tableHombres.style.display = 'table-row-group';
                        } else {
                            tableDamas.style.display = 'table-row-group';
                            tableHombres.style.display = 'none';
                        }
                    }

                    if (productModal) productModal.classList.add('active');
                })
                .catch(err => {
                    console.error('Error loading product:', err);
                    window.location.href = productUrl; // Fallback: go to product page directly
                });
            }
        });
    });

    if (closeProductModalBtn) {
        closeProductModalBtn.addEventListener('click', () => {
            if (productModal) productModal.classList.remove('active');
        });
    }

    const sizeModal = document.getElementById('sizeGuideModal');
    const btnOpenSizeGuide = document.getElementById('openSizeGuide');
    const btnCloseSizeGuide = document.getElementById('closeSizeGuide');

    if (btnOpenSizeGuide) {
        btnOpenSizeGuide.addEventListener('click', (e) => {
            e.preventDefault();
            if (sizeModal) sizeModal.classList.add('active');
        });
    }

    if (btnCloseSizeGuide) {
        btnCloseSizeGuide.addEventListener('click', () => {
            if (sizeModal) sizeModal.classList.remove('active');
        });
    }

    // Close Modals when clicking outside
    window.addEventListener('click', (e) => {
        if (e.target === productModal) {
            productModal.classList.remove('active');
        }
        if (e.target === sizeModal) {
            sizeModal.classList.remove('active');
        }
    });

    // --- Quantity Selector Logic ---
    const qtyInput = document.querySelector('.qty-input');
    const qtyMinus = document.querySelector('.qty-btn.minus');
    const qtyPlus = document.querySelector('.qty-btn.plus');
    
    if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
            let val = parseInt(qtyInput.value) || 1;
            if (val > 1) qtyInput.value = val - 1;
        });
    }
    if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', () => {
            let val = parseInt(qtyInput.value) || 1;
            qtyInput.value = val + 1;
        });
    }

    // --- Shopping Cart Logic (SHOPIFY AJAX) ---
    const openCartBtn = document.getElementById('openCartBtn');
    const closeCartBtn = document.getElementById('closeCartBtn');
    const cartOverlay = document.getElementById('cartOverlay');
    const cartDrawer = document.getElementById('cartDrawer');
    const cartItemsContainer = document.getElementById('cartItemsContainer');
    const cartSubtotalValue = document.getElementById('cartSubtotalValue');
    const cartCountBadge = document.querySelector('.cart-count');

    function toggleCart() {
        if (!cartDrawer || !cartOverlay) return;
        cartDrawer.classList.toggle('active');
        cartOverlay.classList.toggle('active');
    }

    if (openCartBtn) openCartBtn.addEventListener('click', (e) => { e.preventDefault(); toggleCart(); });
    if (closeCartBtn) closeCartBtn.addEventListener('click', toggleCart);
    if (cartOverlay) cartOverlay.addEventListener('click', toggleCart);

    function fetchCart() {
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            updateCartUI(cart);
        })
        .catch(err => console.error('Error fetching cart:', err));
    }

    function changeItemQuantity(key, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
        })
        .then(res => res.json())
        .then(cart => {
            updateCartUI(cart);
        })
        .catch(err => console.error('Error updating cart:', err));
    }

    function updateCartUI(cart) {
        if (!cartItemsContainer || !cartSubtotalValue) return;
        
        cartItemsContainer.innerHTML = '';
        
        if (cart.item_count === 0) {
            cartItemsContainer.innerHTML = '<div class="empty-cart-msg">Tu carrito está vacío actualmente.</div>';
        } else {
            cart.items.forEach((item) => {
                const itemHTML = `
                    <div class="cart-item">
                        <img src="${item.image}" alt="${item.product_title}" class="cart-item-img">
                        <div class="cart-item-info">
                            <h4 class="cart-item-title">${item.product_title}</h4>
                            <div class="cart-item-size">${item.variant_title && item.variant_title !== 'Default Title' ? 'Talla: ' + item.variant_title : ''}</div>
                            <div class="cart-item-price">$${(item.price / 100).toLocaleString('es-CO')} COP</div>
                            <div class="cart-item-controls">
                                <div class="cart-qty-selector">
                                    <button class="cart-qty-btn minus" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                                    <input type="number" class="cart-qty-input" value="${item.quantity}" readonly>
                                    <button class="cart-qty-btn plus" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                                </div>
                                <button class="cart-remove-btn" data-key="${item.key}" data-qty="0">Eliminar</button>
                            </div>
                        </div>
                    </div>
                `;
                cartItemsContainer.innerHTML += itemHTML;
            });
        }

        cartSubtotalValue.textContent = `$${(cart.total_price / 100).toLocaleString('es-CO')} COP`;
        
        // Update header badge if it exists
        const countBadges = document.querySelectorAll('.cart-count');
        countBadges.forEach(badge => {
            badge.textContent = cart.item_count;
            if(cart.item_count > 0) {
                badge.style.display = 'flex';
            } else {
                badge.style.display = 'none';
            }
        });
        
        attachCartListeners();
    }

    function attachCartListeners() {
        document.querySelectorAll('.cart-qty-btn, .cart-remove-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const key = e.target.getAttribute('data-key');
                const qty = parseInt(e.target.getAttribute('data-qty'));
                changeItemQuantity(key, qty);
            });
        });
    }

    // Connect 'Añadir al Carrito' in Quick View
    const addToCartBtn = document.querySelector('.add-to-cart-btn');
    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', () => {
            if (!selectedVariantId) {
                alert('Por favor selecciona una talla.');
                return;
            }

            const qty = qtyInput ? parseInt(qtyInput.value) : 1;
            addToCartBtn.textContent = 'AÑADIENDO...';
            addToCartBtn.disabled = true;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: selectedVariantId,
                    quantity: qty
                })
            })
            .then(res => res.json())
            .then(item => {
                // Success
                addToCartBtn.textContent = 'AÑADIDO ✓';
                setTimeout(() => {
                    addToCartBtn.textContent = 'AÑADIR AL CARRITO';
                    addToCartBtn.disabled = false;
                }, 2000);
                
                fetchCart();
                if(productModal) productModal.classList.remove('active');
                toggleCart();
            })
            .catch(err => {
                console.error('Error adding to cart:', err);
                addToCartBtn.textContent = 'ERROR';
                addToCartBtn.disabled = false;
            });
        });
    }

    // Connect 'Comprar Ahora'
    const buyNowBtn = document.querySelector('.buy-now-btn');
    if (buyNowBtn) {
        buyNowBtn.addEventListener('click', () => {
            if (!selectedVariantId) {
                alert('Por favor selecciona una talla.');
                return;
            }
            const qty = qtyInput ? parseInt(qtyInput.value) : 1;
            
            buyNowBtn.textContent = 'REEDIRIGIENDO...';
            buyNowBtn.disabled = true;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: selectedVariantId,
                    quantity: qty
                })
            })
            .then(() => {
                window.location.href = '/checkout';
            });
        });
    }

    // Initial render cart from Shopify API
    fetchCart();

});
